/* eslint react/prop-types: 0 */

import React from "react";
import moment from "moment";
import _ from "lodash";

function DetailsCard (props) {
  const {details} = props;
  // moment(details.completedAt).format("MM"))
  return (
    <div className="DetailsCard card">
      <div className='title'>
        <h3>{details.playbookTemplateName}</h3>
        <div>Catalog Reference # {details.refUid}</div>
        <div>Generated {moment(details.completedAt).format("MMMM D, YYYY")}</div>
      </div>
      <div>
        <h3>School</h3>
        <div>{details.schoolName}</div>
        <div>{details.schoolInfo.city}, {details.schoolInfo.state}</div>
        <div className='schoolDetails'>
          <div>Team</div> <div>{details.schoolTeamName}</div>
          <div>Initials</div> <div>{details.schoolInitials}</div>
          <div>Mascot</div> <div>{details.schoolMascot}</div>
          <div>Colors</div> <div>{ _.join(details.schoolColorNames, ", ")}</div>
        </div>
      </div>
      <div>
        <h3>Dealer</h3>
        <div>{details.dealerName}</div>
        <div>{details.dealerInfo.phone}</div>
        <div></div>
      </div>
      <div>
        <h3>Sales Representative</h3>
        <div>{details.salesRepName}</div>
        <div>{details.salesRepInfo.city}, {details.salesRepInfo.state}</div>
        <div>{details.salesRepInfo.phone}</div>
      </div>
    </div>
  );
}

export default DetailsCard;


// WEBPACK FOOTER //
// ./src/components/DetailsCard/DetailsCard.js